import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { Library } from '../models/library';
import { BehaviorSubject, catchError, filter, map, Observable, of, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';

@Injectable({
  providedIn: 'root'
})
export class LibraryService {
   private folderName: string | null = null;
  private baseUrl: string = `${environment['api_backend']}/api`

  // TOKEN PARA API RECOGNITION
  private headers = new HttpHeaders({
    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRfdWlkIjoiY2IxNDk2Y2QtOTJhZi00YjE0LWFiZWItMjMwZWUzZGU5ZjA4IiwiY2xpZW50X2lkIjo0LCJpYXQiOjE3MjI0ODIzOTIsImV4cCI6MTcyMjQ5MzE5Mn0.6VEgFrRSx9uHEGWpAMhJViRzxwnOc7EyamkgrhnEojw`,
    'Accept': 'application/json'
  });
  private LibrarySubject = new BehaviorSubject<Library[]>([]);
  library$ = this.LibrarySubject.asObservable().pipe(
    filter(library => library.length > 0));

  

  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error);
    return throwError(error);
  }
  constructor(private http: HttpClient) { };

  updateLibrary(library: Partial<Library>, libraryId: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.patch<Library>(`${this.baseUrl}/library-objects/${libraryId}`, library, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }
  getLibraryById(libraryId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/library-objects/${libraryId}`);
  }

  createLibrary(library: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.baseUrl}/library-objects`, library, { headers })
      .pipe(
        catchError(this.handleError)
      )
  };


 loadLibraryStore(query: any): Observable<{ data: any[]; meta: { totalItems: number } }> {
  let params = new HttpParams();

  Object.keys(query).forEach(key => {
    const value = query[key];
    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach(v => params = params.append(key, v));
      } else {
        params = params.set(key, value);
      }
    }
  });

  return this.http.get<{ data: any[]; meta: { totalItems: number } }>(
    `${this.baseUrl}/library-objects`,
    { params }
  ).pipe(catchError(this.handleError));
}


  
  deleteLibrary(libraryId: number): Observable<Library> {
    return this.http.delete<Library>(`${this.baseUrl}/library-objects/${libraryId}`)
  }

  uploadImages(formData: FormData) {
      return this.http
        .post<{ folderName: string , fileName: string}>(`${this.baseUrl}/gcs/upload`, formData)
        .pipe(tap((res) => (this.folderName = res.folderName)));
    }
  
  urlBucket(path: string, bucketName: string){
     return this.http.post<{url: string[]}>(`${this.baseUrl}/gcs/list-url`, {
       folder: path,
       bucketName:bucketName
     })
  }

  getBrands(): Observable<any[]> {
    console.log('Ingresando..')
    return this.http.get<any[]>(`${this.baseUrl}/library-brands`)
  }

  getCategories(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-categories`)
  }

  getShapes(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-shapes`)
  }

  getPackages(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-packages`)
  }

  getLines(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-lines`)
  }

  getFlavors(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-flavors`)
  }

  getMultipackages(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-multipackages`)
  }
  
  getSizes(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-sizes`)
  }

  getCompanies(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-companies`)
  }


  getEan(): Observable<any[]>{
    return this.http.get<any[]>(`${this.baseUrl}/library-ean`)
  }
 
 getData(d: any): Observable<any[]> {
  console.log('Recibido en getData:', d, 'tipo:', d.type, 'typeof:', typeof d.type);
  switch (d.type) {
    case 'brand':
      return this.getBrands();
    case 'category':
      return this.getCategories();
    case 'shape':
      return this.getShapes();
    case 'package':
      return this.getPackages();
    case 'line':
      return this.getLines();
    case 'flavor':
      return this.getFlavors();
    case 'multipackage':
      return this.getMultipackages();
    case 'size':
      return this.getSizes();
    case 'company':
      return this.getCompanies();
    case 'ean':
      return this.getEan();
    default:
      console.warn(`No existe una función para el tipo: ${d.type}`);
      return of([]); 
  }
}



}
